import { useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSnackbar } from 'notistack';
import { FormFeedback, FormGroup, Input as ReactstrapInput } from 'reactstrap';

import Button from 'src/componentes/button';
import Checkbox from 'src/componentes/checkbox';
import Dialog from 'src/componentes/dialog';
import Input from 'src/componentes/input';
import http from 'src/services/httpService';
import errorHandler from 'src/utils/error-handler';

function GerarRespostasTesteCargaDialog({
  entidadeId,
  entidadeLabel,
  entidadeNome,
  exibirOpcaoVariarColaboradores = false,
  variarColaboradoresLabel,
  ...rest
}) {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const dialogRef = useRef(null);

  const [
    quantidadeRespostasPorColaborador,
    setQuantidadeRespostasPorColaborador,
  ] = useState(1);
  const [variarColaboradores, setVariarColaboradores] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [tentouEnviar, setTentouEnviar] = useState(false);

  const quantidade = Number(quantidadeRespostasPorColaborador);
  const quantidadeInvalida = !Number.isInteger(quantidade) || quantidade <= 0;

  const handleClose = () => {
    if (!isLoading) dialogRef.current?.close();
  };

  const handleQuantidadeChange = (event) => {
    const value = event.target.value;
    setQuantidadeRespostasPorColaborador(value === '' ? '' : Number(value));
  };

  const handleSubmit = async () => {
    setTentouEnviar(true);

    if (quantidadeInvalida) return;

    try {
      setIsLoading(true);

      await http.post('/FormularioGlobalRespostas/GerarRespostasTesteCarga', {
        entidadeId,
        quantidadeRespostasPorColaborador: quantidade,
        variarColaboradores,
      });

      enqueueSnackbar(
        intl.formatMessage({
          id: 'labelJobTesteCargaFormularioGlobalCriadoComSucesso',
        }),
        { variant: 'success' }
      );

      dialogRef.current?.close();
    } catch (error) {
      errorHandler(error);
      setIsLoading(false);
    }
  };

  const actions = [
    <Button
      key="cancelar"
      color="secondary"
      disabled={isLoading}
      onClick={handleClose}
    >
      {intl.formatMessage({
        id: 'label.cancelar',
      })}
    </Button>,
    <Button
      key="criar-job"
      className="ml-2"
      disabled={isLoading || quantidadeInvalida}
      onClick={handleSubmit}
    >
      {intl.formatMessage({
        id: 'labelCriarJob',
      })}
    </Button>,
  ];

  return (
    <Dialog
      ref={dialogRef}
      width={520}
      title={intl.formatMessage({
        id: 'labelGerarRespostasTesteCarga',
      })}
      ignoreResourceTitle
      textCapitalizeTitle={false}
      titleCapitalizeNone
      padContent
      actions={actions}
      onRequestClose={handleClose}
      isLoading={isLoading}
      allowMaximize={false}
      {...rest}
    >
      <p className="text-muted">
        {intl.formatMessage({
          id: 'labelGerarRespostasTesteCargaFormularioGlobalDescricao',
        })}
      </p>

      <Input
        disabled
        model={{
          label: entidadeLabel,
          value: entidadeNome || '',
          requestChange: () => {},
        }}
      />

      <FormGroup>
        <label htmlFor="quantidade-respostas-teste-carga">
          {intl.formatMessage({
            id: 'labelQuantidadeRespostasPorColaborador',
          })}
        </label>
        <ReactstrapInput
          id="quantidade-respostas-teste-carga"
          type="number"
          min={1}
          step={1}
          required
          invalid={tentouEnviar && quantidadeInvalida}
          value={quantidadeRespostasPorColaborador}
          onChange={handleQuantidadeChange}
        />
        <FormFeedback>
          {intl.formatMessage({
            id: 'labelInformeQuantidadeRespostasValida',
          })}
        </FormFeedback>
      </FormGroup>

      {exibirOpcaoVariarColaboradores && (
        <Checkbox
          className="mb-3"
          model={{
            label: variarColaboradoresLabel,
            value: variarColaboradores,
            requestChange: setVariarColaboradores,
          }}
        />
      )}
    </Dialog>
  );
}

export default GerarRespostasTesteCargaDialog;
